module.exports = __webpack_public_path__ + "media/images/emblems/Courchapoix-Blazono-a383d65e5b982f5e5e4a0c6fd2dd36d0.png";